import React, { Component } from 'react';
import { Row, Col } from 'antd';

import LayoutWrapper from '../UI/LayoutWrapper';
import PageHeader from '../UI/PageHeader';
import Box from '../UI/Box';
import ContentHolder from '../UI/ContentHolder';
import Button from '../UI/Button';

import DashboardStyleWrapper from './dashboard.style';

class Dashboard extends Component {
  handleOrderNew = () => {
    this.props.history.push('/orders/new');
  };

  logout = () => {
    localStorage.removeItem('auth');
    this.props.history.push('/login');
  };

  render() {
    return (
      <DashboardStyleWrapper>
        <LayoutWrapper>
          <PageHeader>Welkom</PageHeader>
          <Row
            style={{
              width: '100%',
              display: 'flex',
              flexFlow: 'row wrap',
            }}
            gutter={16}
            justify="start"
          >
            <Col
              md={16}
              sm={16}
              xs={24}
              style={{ marginBottom: '16px' }}
            >
              <Row
                gutter={0}
                justify="start"
              >
                <Col
                  md={24}
                  sm={24}
                  xs={24}
                  style={{ marginBottom: '16px' }}
                >
                  <Box title="Bestellen">
                    <ContentHolder>
                      <Button type="primary" onClick={this.handleOrderNew}>
                        Nieuwe bestelling
                      </Button>
                    </ContentHolder>
                  </Box>
                </Col>
              </Row>
              <Row
                style={{
                  width: '100%',
                  display: 'flex',
                  flexFlow: 'row wrap',
                }}
                gutter={0}
                justify="start"
              >
                <Col
                  md={24}
                  sm={24}
                  xs={24}
                  style={{ marginBottom: '16px' }}
                >
                  <Box
                    title="Vorige Bestellingen"
                    subtitle="Nog geen bestellingen."
                  />
                </Col>
              </Row>
            </Col>
            <Col
              md={8}
              sm={8}
              xs={24}
              style={{ marginBottom: '16px' }}
            >
              <Box title="Profiel">
                <ContentHolder>
                  <div className="isoContactInfoWrapper">
                    <div className="isoContactCardInfos">
                      <p className="isoInfoLabel">E-mail</p>
                      <p className="isoInfoDetails">davy@codens.be</p>
                    </div>
                  </div>
                  <div className="isoContactInfoWrapper">
                    <div className="isoContactCardInfos">
                      <p className="isoInfoLabel">Naam</p>
                      <p className="isoInfoDetails">Davy Declerck</p>
                    </div>
                  </div>
                  <div className="isoContactInfoWrapper">
                    <div className="isoContactCardInfos">
                      <p className="isoInfoLabel">Leveradres</p>
                      <p className="isoInfoDetails">Ter Waarde 50<br />8900 Ieper</p>
                    </div>
                  </div>
                  <div className="isoLeftRightComponent">
                    <div />
                    <Button onClick={this.logout}>
                      Afmelden
                    </Button>
                  </div>
                </ContentHolder>
              </Box>
            </Col>
          </Row>
        </LayoutWrapper>
      </DashboardStyleWrapper>
    );
  }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.js